import "./leftpanel.css";
import "@esri/calcite-components/dist/components/calcite-fab";
import "@esri/calcite-components/dist/components/calcite-tooltip";
import infoIcon from "./../assets/images/info.png";
import logoKAM from "./../assets/images/logo_kam.png";
import { useEffect, useState, useRef } from "react";
import "@esri/calcite-components/dist/components/calcite-link";

import texts from "../assets/texts/texts.js";
import useIsMobile from "./MobileDetection.jsx";





function LeftBar({ onChange, view }) {
  const [viewRedy, setViewRedy] = useState(false);
    const [isMobile, setIsmobile] = useState(false);
  const [home, setHome] = useState(null);
  const visibleHandler = () => {
    onChange(true);
  };

  const buttonRef = useRef(null);
  const tooltipRef = useRef(null);

  useEffect(() => {
    if (buttonRef.current && tooltipRef.current) {
      tooltipRef.current.referenceElement = buttonRef.current;
    }
  }, []);
  const isMobileFunction = useIsMobile();

  useEffect(() => {
    if (viewRedy === false && view) {
      setIsmobile(isMobileFunction)
      setViewRedy(true);
      const home = document.querySelector("#homeWidget");
      setHome(home);
    }
  }, [view]);
  return (
    <>
      <div id="leftpanel">
        <calcite-button
          id="action-info"
          className="leftpanel__button"
          scale="s"
          onClick={() => {
            visibleHandler();
          }}
          ref={buttonRef}
        >
          <img
            id="button-info"
            className="infoIcons__ikons"
            src={infoIcon}
            alt={texts.leftbar.info}
            
          />
        </calcite-button>

        <calcite-button
          id="button-home"
          onClick={() => {
            home.go();
          }}
          className="leftpanel__button"
          scale="s"
        >
          <calcite-icon v icon="home" scale="l"></calcite-icon>
        </calcite-button>


        <div id="button-language" className="ikons__language leftpanel__button">
          <a  href={texts.leftbar.language.url}>{texts.leftbar.language.language}</a >
        </div>

        {!isMobile && (<>
        <calcite-tooltip ref={tooltipRef} overlay-positioning="fixed" >
          <span className="my-tooltip-text">{texts.leftbar.info}</span>
        </calcite-tooltip>
        
        <calcite-tooltip reference-element="button-home">
          <span className="my-tooltip-text">{texts.leftbar.home}</span>
        </calcite-tooltip>
  
        <calcite-tooltip reference-element="button-language">
          <span className="my-tooltip-text">{texts.leftbar.language.title}</span>
        </calcite-tooltip>
              </>
        )}
      </div>

      <p className="foterDescription ">{texts.title.toUpperCase()}</p>
      <a  className="foterLogoKam" href="https://kambrno.cz/" target="_blank">
        <img className="logoKam leftpanel__button" src={logoKAM} alt="" />
      </a >
    </>
  );
}

export default LeftBar;
